import { gql } from '@apollo/client';

const BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPPC = gql`
  fragment BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPPC on InvoiceGroupConnection {
    totalCount
    nodes {
      id
      name
      currency
      transactionAccountId
      isActive
      invoiceGroupNumber
      shipToParty {
        id
        name
        addressLine1
        addressLine2
        city
        country
        state
        phone
        postcode
        taxId
        taxIds {
          id
          label
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      defaultPaymentMethod(refetchDefaultPaymentMethod: $refetchDefaultPaymentMethod) {
        id
        type
        paymentIssue
        default
        ... on CreditCard {
          card {
            expirationMonth
            expirationYear
            last4Numbers
            brand
          }
        }
        ... on PaymentOnTerms {
          terms {
            invoiceDueDays
            payOnStatement
          }
        }
        ... on PayPal {
          payPal {
            name
            email
          }
        }
        ... on Ach {
          ach {
            bankName
            last4
          }
        }
      }
      shipToPriceEligibility
      purchaseOrder {
        number
        oneTimeUse
      }
      createdAt
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
`;

export const fetchCustomerBillingProfilesForTxaInPPC = gql`
  ${BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPPC}
  query fetchCustomerBillingProfilesForTxaInPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $refetchDefaultPaymentMethod: Boolean = false
    $isFetchBillingProfilesViaCCPEnabled: Boolean = false
  ) {
    transactionAccount(id: $id) {
      id
      billingProfiles(searchOptions: $searchOptions, filterOptions: $filterOptions)
        @skip(if: $isFetchBillingProfilesViaCCPEnabled) {
        ...BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPPC
      }
      billingProfilesFromCCP(searchOptions: $searchOptions, filterOptions: $filterOptions)
        @include(if: $isFetchBillingProfilesViaCCPEnabled) {
        ...BillingProfileDetailsForFetchCustomerBillingProfilesForTxaInPPC
      }
    }
  }
`;
